import { translate } from '../services/translate'

export const sections = ({ insightsEnabled, surveyEnabled, dealsEnabled, excoEnabled, specialProjectsEnabled, operatingCostsEnabled }, isWrapUp) => {
  return [{
    title: translate('mainMenu.informationLabel', 'INFORMATION'),
    items: [{
      id: 'Summary',
      title: translate('mainMenu.summaryButton', 'Summary'),
      logo: 'summary',
      enabled: true
    }, {
      id: 'BreakingNews',
      title: translate('mainMenu.newsButton', 'Breaking News'),
      logo: 'news',
      enabled: !isWrapUp
    }, {
      id: 'PeerInsights',
      title: translate('mainMenu.peerInsightsButton', 'Peer Insights'),
      logo: 'peer',
      enabled: insightsEnabled
    }, {
      id: 'OurFinancials',
      title: translate('mainMenu.ourFinancialsButton', 'Our Financials'),
      logo: 'finance',
      enabled: true
    }, {
      id: 'HelpManual',
      title: translate('mainMenu.helpManualButton', 'Help Manual'),
      logo: 'help',
      enabled: true
    }].filter(({ enabled }) => {
      return enabled
    })
  }, {
    title: translate('mainMenu.decisionsLabel', 'DECISIONS'),
    items: [{
      id: 'Opex',
      title: translate('mainMenu.costsButton', 'Costs'),
      logo: 'opex',
      enabled: operatingCostsEnabled
    }, {
      id: 'SpecialProjects',
      title: translate('mainMenu.specialProjectsButton', 'Special Projects'),
      logo: 'special',
      enabled: specialProjectsEnabled
    }, {
      id: 'DealRoom',
      title: translate('mainMenu.dealRoomButton', 'Deal Room'),
      logo: 'deal',
      enabled: dealsEnabled
    }, {
      id: 'Treasury',
      title: translate('mainMenu.treasuryButton', 'Treasury'),
      logo: 'treasure',
      enabled: true
    }, {
      id: 'ExcoDecision',
      title: translate('mainMenu.excoButton', 'Exco Decision'),
      logo: 'dice',
      enabled: excoEnabled
    }, {
      id: 'Businesses',
      title: translate('mainMenu.businessesButton', 'Businesses'),
      logo: 'business',
      enabled: true
    }, {
      id: 'Survey',
      title: translate('mainMenu.feedbackButton', 'Feedback'),
      logo: 'survey',
      enabled: surveyEnabled
    }].filter(({ enabled }) => {
      return !isWrapUp && enabled
    })
  }]
}
